import type { GoodsData } from '@banhala/ui-kit';
import type { MarketHomeGoodsItem } from 'shared/src/api';

export const convertMarketHomeGoodsItemToGoodsData = (
  input: MarketHomeGoodsItem,
): GoodsData & MarketHomeGoodsItem => {
  return {
    ...input,
    sno: input.item.sno,
    deliveryType: input.item.delivery_type,
    thumbnail: {
      src: input.render.data.image.url,
      freesSrc: input.render.data.image.url,
      closedReason: input.render.data.closed_reason ?? undefined,
      badges: input.render.data.image_badge_list.map(badge => ({
        uri: badge.image_url,
        width: badge.image_width,
        height: badge.image_height,
      })),
    },
    contents: {
      price: {
        price: input.render.data.price,
        discount: input.render.data.discount_rate ?? undefined,
      },
      name: {
        goodsName: input.render.data.name,
        marketName: input.render.data.store_text,
        nameLineCount: input.render.data.name_lines,
        showBrand: false,
      },
      topNudging: input.render.data.top_nudging_text ?? undefined,
      priceDescription: input.render.data.price_description
        ? { name: input.render.data.price_description.text }
        : undefined,
      imageAd: input.render.data.has_ad_badge,
      nudge: input.render.data.nudging_text ?? undefined,
      chips: input.render.data.chips.map(chip => {
        if (chip.meta) {
          return {
            type: chip.type,
            name: chip.name,
            customTag: chip.meta
              ? {
                  bgColor: chip.meta.bg_color,
                  borderColor: chip.meta.border_color,
                  borderWidth: chip.meta.border_width,
                  borderRadius: chip.meta.rounded_corner_radius,
                  textColor: chip.meta.text_color,
                  textType: chip.meta.text_style,
                }
              : undefined,
          };
        }
        return {
          type: chip.type,
          name: chip.name,
        };
      }),
    },
  };
};
